"use client";

import { BadgeCheck, LockKeyhole } from "lucide-react";

import { BrokerAvatar } from "@/components/brokers/broker-avatar";
import { cn } from "@/lib/utils";

export type PortalBrandProps = {
  name: string;
  avatarUrl?: string | null;
  subtitle?: string | null;
  className?: string;
};

export function PortalBrand({
  name,
  avatarUrl,
  subtitle,
  className,
}: PortalBrandProps) {
  const displayName = name.trim() || "Your broker";
  const detail = subtitle?.trim();

  return (
    <div className={cn("flex min-w-0 items-center gap-2.5", className)}>
      <BrokerAvatar
        id={displayName}
        name={displayName}
        image={avatarUrl}
        showVerified={false}
        size="xs"
        className="size-7"
      />
      <span className="min-w-0">
        <span className="block truncate text-sm font-medium leading-tight text-foreground">
          <span className="inline-flex max-w-full items-center gap-1.5">
            <span className="truncate">{displayName}</span>
            <BadgeCheck
              className="size-4 shrink-0 text-sky-500"
              aria-label="Verified broker"
            />
          </span>
        </span>
        {detail ? (
          <span className="mt-0.5 flex min-w-0 items-center gap-1 text-[11px] leading-tight text-muted-foreground">
            <LockKeyhole className="size-3 shrink-0" aria-hidden />
            <span className="truncate">{detail}</span>
          </span>
        ) : null}
      </span>
    </div>
  );
}
